/**
 * Aparência dos selos de função (Líder do Ministério, Gestor de elo e funções comuns).
 * Fica num lugar só para a tela do ministério e as ilustrações da Ajuda mostrarem o MESMO selo.
 *
 * Líder: âmbar (warning). Gestor de elo: azul (info), de propósito diferente do verde da marca,
 * que é o das funções comuns. Convite ainda não aceito: borda tracejada, sem fundo.
 * No tema escuro o azul puro perde contraste sobre o fundo: o selo do Gestor ganha um fundo mais
 * forte e o texto na cor normal.
 */
export const CLASSE_SELO_LIDER = "bg-warning/10 text-warning";
export const CLASSE_SELO_LIDER_CONVIDADO = "border border-dashed border-warning/60 text-warning";
export const CLASSE_SELO_GESTOR = "bg-info/10 text-info dark:bg-info/30 dark:text-text";
export const CLASSE_SELO_GESTOR_CONVIDADO =
  "border border-dashed border-info/60 text-info dark:border-info dark:text-text";
export const CLASSE_SELO_COMUM = "bg-primary/10 text-primary";

export const ROTULO_GESTOR_DE_ELO = "Gestor de elo";

/**
 * Texto do selo do Gestor de elo. Função chamada "Gestor de elo" mostra só isso; com outro nome
 * (ex.: "Bibliotecário"), o nome vai junto: "Gestor de elo · Bibliotecário". Mesmo jeito do selo
 * do líder.
 */
export function rotuloDoGestor(funcaoNome: string): string {
  const nome = funcaoNome.trim();
  return nome.toLowerCase() === ROTULO_GESTOR_DE_ELO.toLowerCase()
    ? ROTULO_GESTOR_DE_ELO
    : `${ROTULO_GESTOR_DE_ELO} · ${nome}`;
}
